module.exports = __webpack_public_path__ + "img/9791158886554.63bc7e90.jpg";